import {
  Component,
  computed,
  input
} from '@angular/core';
import { AssetCategoryGroupType } from '../../../domain/lti/asset-allocation.domain';

@Component({
  selector: 'td-wb-lti-asset-category-group-icon',
  template: '<span [class]="\'td-wb-lti-asset-category-icon \' + assetCategoryGroupClass()"></span>',
  styleUrls: ['./asset-category-icon.component.scss']
})
export class AssetCategoryGroupIconComponent {

  private static readonly ASSET_CATEGORY_GROUP_COLOR_CLASS: Map<AssetCategoryGroupType, string> = new Map<AssetCategoryGroupType, string>([
    [AssetCategoryGroupType.EQUITIES, 'td-wb-lti-asset-category-group-equities'],
    [AssetCategoryGroupType.CASH_AND_FIXED_INCOME, 'td-wb-lti-asset-category-group-cash_and_fixed_income']
  ]);

  private static readonly ASSET_CATEGORY_GROUP_MISSING_CLASS: string = 'td-wb-lti-asset-category-group-missing';

  readonly assetCategoryGroupType = input<AssetCategoryGroupType>(undefined);

  readonly assetCategoryGroupClass = computed((): string => this.getAssetCategoryGroupStyle(this.assetCategoryGroupType())
    ?? AssetCategoryGroupIconComponent.ASSET_CATEGORY_GROUP_MISSING_CLASS);

  private getAssetCategoryGroupStyle(assetCategoryGroupType: AssetCategoryGroupType | undefined): string {
    return AssetCategoryGroupIconComponent.ASSET_CATEGORY_GROUP_COLOR_CLASS.get(assetCategoryGroupType);
  }

}

